import axios from "axios";
import CONFIG from "../../util/config";

const authState = {
  isAuthenticated: window.localStorage.getItem(CONFIG.tokenStorageName) != null
};

function loginComponent(login, password) {
  const auth = {
    Login: login,
    Password: password
  };

  const authEndpoint = `${CONFIG.serverUrl}/account/logar`;
  return axios.post(authEndpoint, auth).then(res => {
    const auth = res.data;
    window.localStorage.setItem(CONFIG.tokenStorageName, auth);
    window.localStorage.removeItem(CONFIG.selectedCompanyStorageName);
    authState.isAuthenticated = true;
  });
}

function recoverComponent(login, password) {
  const auth = {
    Login: login,
    Password: password
  };

  const authEndpoint = `${CONFIG.serverUrl}/account/recuperar`;
  return axios.post(authEndpoint, auth).then(res => {
    return res.data;
  });
}

function logout() {
  authState.isAuthenticated = false;
  window.localStorage.removeItem(CONFIG.tokenStorageName);
}

export { authState, loginComponent, recoverComponent, logout };



// WEBPACK FOOTER //
// ./src/components/login/auth.jsx